/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeNavGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Nav Group Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const NAVGROUP_LIST_CONTAINER_LOADED = 'NAVGROUP_LIST_CONTAINER_LOADED';
export const NAVGROUP_LIST_CONTAINER_UNLOADED = 'NAVGROUP_LIST_CONTAINER_UNLOADED';
export const NAVGROUP_LIST_TABLE_LOADED = 'NAVGROUP_LIST_TABLE_LOADED';
export const NAVGROUP_LIST_TABLE_UNLOADED = 'NAVGROUP_LIST_TABLE_UNLOADED';
export const NAVGROUP_SELECT_ROW = 'NAVGROUP_SELECT_ROW';
export const NAVGROUP_ADD = 'NAVGROUP_ADD';
export const NAVGROUP_EDIT = 'NAVGROUP_EDIT';
export const NAVGROUP_DELETE = 'NAVGROUP_DELETE';
export const NAVGROUP_DELETE_DISABLE = 'NAVGROUP_DELETE_DISABLE';
export const NAVGROUP_OPEN_WARNING = 'NAVGROUP_OPEN_WARNING';
export const NAVGROUP_CLOSE_WARNING = 'NAVGROUP_CLOSE_WARNING';
export const NAVGROUP_VIEW_NAVS = 'NAVGROUP_VIEW_NAVS';

export const NAVGROUP_EDIT_CONTAINER_LOADED = 'NAVGROUP_EDIT_CONTAINER_LOADED';
export const NAVGROUP_EDIT_CONTAINER_UNLOADED = 'NAVGROUP_EDIT_CONTAINER_UNLOADED';
export const NAVGROUP_EDIT_FORM_LOADED = 'NAVGROUP_EDIT_FORM_LOADED';
export const NAVGROUP_EDIT_FORM_UNLOADED = 'NAVGROUP_EDIT_FORM_UNLOADED';
export const NAVGROUP_EDIT_DATA_LOAD = 'NAVGROUP_EDIT_DATA_LOAD';
export const NAVGROUP_EDIT_CONTAINER_SUBMIT = 'NAVGROUP_EDIT_CONTAINER_SUBMIT';
export const NAVGROUP_EDIT_CONTAINER_CANCEL = 'NAVGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeNavGroups.js